import React, { useEffect, useState } from 'react';
import { createWorkshop, getWorkshopById, updateWorkshop } from '../../Api/Api';
import { useNavigate, useParams } from 'react-router-dom';

const WorkshopForm = () => {
    const [workshop, setWorkshop] = useState({ name: '', address: '' });
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            getWorkshopById(id)
                .then((response) => setWorkshop(response.data))
                .catch((error) => console.error('Error fetching workshop:', error));
        }
    }, [id]);

    const handleChange = (e) => {
        setWorkshop({ ...workshop, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (id) {
            updateWorkshop(id, workshop)
                .then(() => navigate('/workshops'))
                .catch((error) => console.error('Error updating workshop:', error));
        } else {
            createWorkshop(workshop)
                .then(() => navigate('/workshops'))
                .catch((error) => console.error('Error creating workshop:', error));
        }
    };

    return (
        <div className="max-w-2xl mx-auto p-6 bg-white shadow-md rounded-lg">
            <h2 className="text-2xl font-semibold mb-6">{id ? 'Edit Workshop' : 'Add Workshop'}</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name</label>
                    <input
                        id="name"
                        type="text"
                        name="name"
                        value={workshop.name}
                        onChange={handleChange}
                        placeholder="Enter workshop name"
                        required
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>

                <div className="mb-4">
                    <label htmlFor="address" className="block text-sm font-medium text-gray-700">Address</label>
                    <input
                        id="address"
                        type="text"
                        name="address"
                        value={workshop.address}
                        onChange={handleChange}
                        placeholder="Enter workshop address"
                        required
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>

                <div className="flex items-center justify-end space-x-4">
                    <button
                        type="submit"
                        className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400"
                    >
                        {id ? 'Update Workshop' : 'Add Workshop'}
                    </button>
                    <button
                        type="button"
                        onClick={() => navigate('/workshops')}
                        className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-300"
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    );
};

export default WorkshopForm;
